import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSurveyTheme, createSurveyStyles } from '@sm/webassets';
import './layout.scss';

const useStyles = createSurveyStyles(theme => {
  let bgColor = theme?.primaryBackgroundColor;
  if (theme?.surveyPage?.backgroundImage) {
    bgColor = theme?.surveyPage?.overlayColor;
  }
  return {
    layoutBg: {
      background: {
        position: '50% 50%',
        size: 'cover',
        image: theme?.surveyPage?.backgroundImage,
      },
    },
    layoutBgOverlay: {
      backgroundColor: bgColor,
    },
    partialLayoutContent: {
      color: theme?.questionColor,
      backgroundColor: theme?.primaryBackgroundColor,
      fontFamily: theme?.questionTitle?.fontFamily,
    },
    fullLayoutContent: {
      color: theme?.questionColor,
      fontFamily: theme?.questionTitle?.fontFamily,
    },
  };
});

const Layout = props => {
  let grid;
  const theme = useSurveyTheme();
  const classes = useStyles();
  const [surveyHeader, ...surveyContent] = props.children;

  const layoutClass = classNames({
    'sm-layout--rtl': props.isRTL,
  });

  switch (theme.layout) {
    case 'BACKGROUND_PARTIAL_RIGHT_HALF':
      grid = (
        <>
          <div className={`${classes.partialLayoutContent} sm-layout--float-left`}>{props.children}</div>
          <div className={`${classes.layoutBg} sm-layout--fixed-right`} />
        </>
      );
      break;
    case 'BACKGROUND_PARTIAL_RIGHT_THIRD':
      grid = (
        <>
          <div className={`${classes.partialLayoutContent} sm-layout__twothird--float-left`}>{props.children}</div>
          <div className={`${classes.layoutBg} sm-layout__twothird--fixed-right`} />
        </>
      );
      break;
    case 'BACKGROUND_PARTIAL_LEFT_HALF':
      grid = (
        <>
          <div className={`${classes.layoutBg} sm-layout--fixed-left`} />
          <div className={`${classes.partialLayoutContent} sm-layout--float-right`}>{props.children}</div>
        </>
      );
      break;
    case 'BACKGROUND_PARTIAL_LEFT_THIRD':
      grid = (
        <>
          <div className={`${classes.layoutBg} sm-layout__twothird--fixed-left`} />
          <div className={`${classes.partialLayoutContent} sm-layout__twothird--float-right`}>{props.children}</div>
        </>
      );
      break;
    case 'BACKGROUND_PARTIAL_TOP_BANNER':
      grid = (
        <>
          <div className={`${classes.layoutBg} sm-layout__top-banner`}> {surveyHeader}</div>
          <div className={classes.partialLayoutContent}>
            <div className="sm-layout--full">{surveyContent}</div>
          </div>
        </>
      );
      break;
    case 'BACKGROUND_FULL_TEXT_LEFT':
      grid = (
        <div className={classes.layoutBg}>
          <div className={`${classes.fullLayoutContent} sm-layout--content sm-layout--content-left`}>
            {props.children}
          </div>
        </div>
      );
      break;
    case 'BACKGROUND_FULL_TEXT_RIGHT':
      grid = (
        <div className={classes.layoutBg}>
          <div className={`${classes.fullLayoutContent} sm-layout--content sm-layout--content-right`}>
            {props.children}
          </div>
        </div>
      );
      break;
    default:
      grid = (
        <div className={classes.layoutBg}>
          <div className={classes.layoutBgOverlay}>
            <div className={`${classes.fullLayoutContent} sm-layout--content`}>{props.children}</div>
          </div>
        </div>
      );
      break;
  }
  return (
    <div className={layoutClass} data-testid="Layout__Container">
      {grid}
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
  isRTL: PropTypes.bool,
};

Layout.defaultProps = {
  children: null,
  isRTL: false,
};

export default Layout;
